import { post, get } from "../httpmethods";
import { put } from "../httpmethods";
import { URL_API } from "../config";


export const CompanyAPI = {
    createCompany: async (data) => {
        return await post(`${URL_API}/companies`, data);
    },

    getCompanies: async (data) => {
        return await get(`${URL_API}/companies`, data);
    },

    getCompanyById: async (id) => {
        return await get(`${URL_API}/companies/${id}`);
    },

    updateCompany: async (id, data) => {
        return await put(`${URL_API}/companies/${id}`, data);
    },

    deleteCompany: async (id) => {
        return await post(`${URL_API}/companies/${id}/delete`);
    }
}
